import axios from 'axios';
import authService from './authService';

const API_URL = '/api/';

class ForumService {
  async getTopics() {
    const response = await axios.get(API_URL + 'forum-topics/', {
      headers: authService.authHeader(),
    });
    return response.data;
  }

  async getTopic(id) {
    const response = await axios.get(API_URL + `forum-topics/${id}/`, {
      headers: authService.authHeader(),
    });
    return response.data;
  }

  async createTopic(data) {
    const response = await axios.post(API_URL + 'forum-topics/', data, {
      headers: authService.authHeader(),
    });
    return response.data;
  }

  async updateTopic(id, data) {
    const response = await axios.patch(API_URL + `forum-topics/${id}/`, data, {
      headers: authService.authHeader(),
    });
    return response.data;
  }

  async deleteTopic(id) {
    await axios.delete(API_URL + `forum-topics/${id}/`, {
      headers: authService.authHeader(),
    });
  }

  async createReply(data) {
    const response = await axios.post(API_URL + 'forum-replies/', data, {
      headers: authService.authHeader(),
    });
    return response.data;
  }

  async updateReply(id, data) {
    const response = await axios.patch(API_URL + `forum-replies/${id}/`, data, {
      headers: authService.authHeader(),
    });
    return response.data;
  }

  async deleteReply(id) {
    await axios.delete(API_URL + `forum-replies/${id}/`, {
      headers: authService.authHeader(),
    });
  }
}

const forumService = new ForumService();
export default forumService;
